import { render, staticRenderFns } from "./alImage.vue?vue&type=template&id=5571089e&scoped=true"
import script from "./alImage.vue?vue&type=script&lang=js"
export * from "./alImage.vue?vue&type=script&lang=js"
import style0 from "./alImage.vue?vue&type=style&index=0&id=5571089e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571089e",
  null
  
)

export default component.exports